import { RoutePath } from "@src/interfaces";
import { Routes, Route, Navigate } from "react-router-dom";
import { useSwapContext } from "@src/contexts";
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  DepositLackingFundsView,
  TokenPickerView,
  DepositView,
  HistoryView,
  ProcessingView,
  SettingsView,
  TransferView,
  WalletView,
  WithdrawView,
  MoveCashView,
  RewardsView,
  ChainPickerView,
  UsdcChainPickerView,
  IntegrationsView,
  HomeView,
  DirectOnRampView,
  LoadingView,
} from "@src/views";

export const AppRouter = () => {
  const {
    isDirectOnRampSupported,
    isCheckingDirectOnRamp,
    integrationConfig,
    isFetchingChains,
  } = useSwapContext();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (isDirectOnRampSupported === true) {
      // Only redirect if we're not already on the DirectOnRamp route
      if (location.pathname !== "/directOnRamp") {
        navigate("/directOnRamp", { replace: true });
      }
    }
  }, [isDirectOnRampSupported, navigate, location.pathname]);

  if (
    integrationConfig.dstChainId &&
    integrationConfig.dstTokenAddr &&
    integrationConfig.externalWalletAddress &&
    !isDirectOnRampSupported &&
    (isCheckingDirectOnRamp || isFetchingChains)
  ) {
    return <LoadingView />;
  }

  return (
    <div className={`flex min-w-[344px] max-w-x_modal w-full h-full min-h-0`}>
      <Routes>
        <Route path="/buy" element={<HomeView tab={RoutePath.Buy} />} />
        <Route path="/sell" element={<HomeView tab={RoutePath.Sell} />} />
        <Route path="/integrations" element={<IntegrationsView />} />
        <Route path="/wallet" element={<WalletView />} />
        <Route path="/history" element={<HistoryView />} />
        <Route path="/settings" element={<SettingsView />} />
        <Route path="/pickToken" element={<TokenPickerView />} />
        <Route path="/pickChain" element={<ChainPickerView />} />
        <Route path="/pickUsdcChain" element={<UsdcChainPickerView />} />
        <Route
          path="/depositLackingFunds"
          element={<DepositLackingFundsView />}
        />
        <Route path="/deposit" element={<DepositView />} />
        <Route path="/moveCash" element={<MoveCashView />} />
        <Route path="/withdraw" element={<WithdrawView />} />
        <Route path="/transfer" element={<TransferView />} />
        <Route path="/processing" element={<ProcessingView />} />
        <Route path="/rewards" element={<RewardsView />} />
        <Route path="/directOnRamp" element={<DirectOnRampView />} />
        <Route path="*" element={<Navigate to="/buy" replace />} />
      </Routes>
    </div>
  );
};
